import { MapItemsCache } from 'components/GoogleMap/MapItemsCache'
import type { TBlockId } from 'stores/fieldAssetStore/helperTypes'
import { selectedFieldAssetsStore } from 'stores/selectedFieldAssetsStore/selectedFieldAssetsStore'
import { setSelectedFieldAsset } from 'utils/setSelectedFieldAsset/setSelectedFieldAsset'
import { shouldShowNDVI } from 'utils/shouldShowNDVI'
import { getZoomThresholds } from '../../_utils/zoomVisibility'

type BLOCK_META = {
  blockId: TBlockId
  bounds: google.maps.LatLngBounds
  latLngs: google.maps.LatLng[]
}

export class BlocksDefaultPolygonsCache extends MapItemsCache<BLOCK_META, null, google.maps.Polygon> {
  constructor(options: { maps: typeof google.maps; map: google.maps.Map }) {
    super({
      createOverlay: (o) => {
        const polygon = new o.maps.Polygon({ paths: o.meta.latLngs, map: o.map })

        polygon.addListener('click', () => {
          setSelectedFieldAsset({ block: Number(o.meta.blockId) })
        })

        return polygon
      },
      renderOverlay: (o) => {
        const isSelected = selectedFieldAssetsStore.getState().block === o.meta.blockId
        const mapZoom = o.map.getZoom()
        const ndviIsVisible = shouldShowNDVI() && mapZoom && getZoomThresholds(mapZoom).IMAGE_OVERLAY === 'OK'

        o.overlay.setOptions({
          map: o.map,
          strokeColor: isSelected ? 'yellow' : 'white',
          strokeWeight: isSelected ? 4 : 2,
          strokePosition: o.maps.StrokePosition.CENTER,
          fillOpacity: ndviIsVisible ? 0.01 : 0.3,
        })
      },
      hideOverlay: (o) => {
        o.overlay.setMap(null)
      },
      maps: options.maps,
      map: options.map,
    })
  }
}
